import styled from "styled-components"

import { DefaultStyle } from "Catalog/Edit/shared/components/Navigator"
import { ItemRenderProps } from "Catalog/Edit/shared/components/Navigator/types"

export const Empty = styled.div``

export const StyledDeal = styled.div<ItemRenderProps>`
  ${DefaultStyle.itemCss};
`

export const Name = styled.div<{ isEnabled: boolean }>`
  ${DefaultStyle.nameCss};
  ${({ isEnabled }) => !isEnabled && "text-decoration: line-through;"};
`
